// Module
var code = "<script>let $ctrl</script> <organism-wizard-confirm-view ng-if=\"$ctrl.startRequests\" service-wizard-confirm=\"$ctrl.redirectionWizardConfirmation\" wizard-create-object-list=\"$ctrl.wizardCreateObjectList\"></organism-wizard-confirm-view> ";
// Exports
module.exports = code;